/**
 * Authentication Provider
 * Wraps app with React Query and provides auth context
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

/**
 * React Query client configuration
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      gcTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

interface AuthProviderProps {
  children: ReactNode;
}

/**
 * Auth Provider Component
 * Provides React Query client to the app
 */
export function AuthProvider({ children }: AuthProviderProps) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
